import MobileCompetitor from "@home/pages/studio/competitors/components/MobileCompetitor";
import PcCompetitor from "@home/pages/studio/competitors/components/PcCompetitor";

export default {
  PcCompetitor,
  MobileCompetitor
};